import {
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  TooltipTrigger,
  TooltipContent,
  DropdownMenu,
  Typography,
  Checkbox,
  Markdown,
  Tooltip,
  Button,
} from '@ui/components';
import { NotificationDtoReadStatusEnum, NotificationDto } from '@interfaces/models';
import { NotificationBadge } from '@pages/notifications/components';
import { MenuVertical } from '@ui/components/icons';
import { HasPermission } from '@shared/components';
import { useTranslation } from 'react-i18next';
import { cn } from '@ui/utils';
import { FC } from 'react';

import { NotificationsFooter } from './notifications-footer/notifications-footer';

export interface NotificationElementProps extends NotificationDto {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  onMarkAsRead: () => void;
  onRemove: () => void;
}

export const NotificationElement: FC<NotificationElementProps> = ({
  onCheckedChange,
  onMarkAsRead,
  readStatus,
  createdAt,
  content,
  checked,
  title,
  type,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex gap-4 items-start px-2">
      <div className="flex gap-4 items-center">
        <Checkbox onCheckedChange={onCheckedChange} checked={checked} />

        <NotificationBadge severity={type} />
      </div>

      <section className="flex flex-col gap-1 w-full">
        <Typography
          variant={
            readStatus === NotificationDtoReadStatusEnum.UNREAD
              ? 'paragraphBasicBold'
              : 'paragraphBasicBook'
          }
          className={cn({ 'text-default': readStatus === NotificationDtoReadStatusEnum.UNREAD })}
        >
          {title}
        </Typography>
        <NotificationsFooter createdAt={createdAt}>
          <Typography
            className={cn('text-weak text-wrap', {
              'text-default': readStatus === NotificationDtoReadStatusEnum.UNREAD,
            })}
            variant="paragraphBasicBook"
            element="div"
          >
            <Markdown>{content}</Markdown>
          </Typography>
        </NotificationsFooter>
      </section>

      <HasPermission permissionFeature="NOTIFICATIONS_MANAGE_NOTIFICATIONS" permissionType="WRITE">
        {readStatus === NotificationDtoReadStatusEnum.UNREAD && (
          <DropdownMenu>
            <Tooltip>
              <TooltipTrigger tabIndex={-1} asChild>
                <DropdownMenuTrigger asChild>
                  <Button variant="ghost">
                    <MenuVertical />
                  </Button>
                </DropdownMenuTrigger>
              </TooltipTrigger>
              <TooltipContent className="w-auto">
                <Typography variant="labelXSmallBook">
                  {t('NOTIFICATIONS.TABLE_MORE_ACTIONS')}
                </Typography>
              </TooltipContent>
            </Tooltip>
            <DropdownMenuContent className="w-56">
              <DropdownMenuItem onClick={onMarkAsRead}>
                {t('NOTIFICATIONS.TABLE_MARK_AS_READ')}
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        )}
      </HasPermission>
    </div>
  );
};
